import { MenuModel } from "../models/common/menu.model";
import { ROUTE_PATH } from "./route-path";

export const MAIN_MENU: MenuModel[] = [
  {
    title: 'タグ',
    path: ROUTE_PATH.TAG,
    icon: 'images/icon/menu/users-animated.svg',
    routerLink:'',
    children: [
      {
        title: '利用者タグ割当',
        path: `${ROUTE_PATH.TAG}/${ROUTE_PATH.USERTAG}`,
        icon: 'images/icon/menu/taglink-active.svg',
        routerLink:''
      },
      {
        title: '職員タグ割当',
        path: `${ROUTE_PATH.TAG}/${ROUTE_PATH.STAFFTAG}`,
        icon: 'images/icon/menu/taglink-active.svg',
        routerLink:''
      },
      {
        title: '電池残量確認',
        path: `${ROUTE_PATH.TAG}/${ROUTE_PATH.BATTERYTAG}`,
        icon: 'images/icon/menu/battery-active.svg',
        routerLink:''
      }
  ]
  },
  {
    title: '分析',
    path: ROUTE_PATH.ANALYSIS,
    icon: 'images/icon/menu/chart-bar-animated.svg',
    routerLink:'',
    children: [
      {
        title: '行動履歴',
        path:  `${ROUTE_PATH.ANALYSIS}/${ROUTE_PATH.HISTORY}`,
        icon: 'images/icon/menu/history-active.svg',
        routerLink:''
      },
      {
        title: 'ヒートマップ',
        path: `${ROUTE_PATH.ANALYSIS}/${ROUTE_PATH.HEATMAP}`,
        icon: 'images/icon/menu/heatmap-active.svg',
        routerLink:''
      },
      {
        title: '接触履歴',
        path: `${ROUTE_PATH.ANALYSIS}/${ROUTE_PATH.INTERACT}`,
        icon: 'images/icon/menu/interact-active.svg',
        routerLink:''
      }
    ]
  },
  {
    title: '設定',
    path: ROUTE_PATH.SETTINGS,
    icon: 'images/icon/menu/settings-animated.svg',
    routerLink:'',
    children: [
      {
        title: 'エリア設定',
        path:  `${ROUTE_PATH.SETTINGS}/${ROUTE_PATH.ZONESETTING}`,
        icon: 'images/icon/menu/history-active.svg',
        routerLink:''
      },
      {
        title: 'タグ登録',
        path: `${ROUTE_PATH.SETTINGS}/${ROUTE_PATH.TAGREGISTRATION}`,
        icon: 'images/icon/menu/tagregistration-active.svg',
        routerLink:''
      },
      {
        title: '利用者登録',
        path: `${ROUTE_PATH.SETTINGS}/${ROUTE_PATH.DAIREGISTRATION}`,
        icon: 'images/icon/menu/userregistration-active.svg',
        routerLink:''
      },
      {
        title: '職員登録',
        path: `${ROUTE_PATH.SETTINGS}/${ROUTE_PATH.STAFFREGISTRATION}`,
        icon: 'images/icon/menu/staffregistration-active.svg',
        routerLink:''
      },
      {
        title: '自動記録設定',
        path: `${ROUTE_PATH.SETTINGS}/${ROUTE_PATH.AUTO_RECORDING}`,
        icon: 'images/icon/menu/auto-recording-active.svg',
        routerLink:''
      },
      // {
      //   title: '組織登録',
      //   path: `${ROUTE_PATH.SETTINGS}/${ROUTE_PATH.ORGANIZATIONREGISTRATION}`,
      //   icon: 'images/icon/menu/organizationregistration-active.svg',
      //   routerLink:''
      // },
      {
        title: 'アカウント管理',
        path: `${ROUTE_PATH.SETTINGS}/${ROUTE_PATH.ACCOUNT_MANAGEMENT}`,
        icon: 'images/icon/menu/account-management-active.svg',
        routerLink:''
      },
      {
        title: '画面設定',
        path: `${ROUTE_PATH.SETTINGS}/${ROUTE_PATH.SCREEN_SETTING}`,
        icon: 'images/icon/menu/screen-setting-active.svg',
        routerLink:''
      }
    ]
  }
];
